import "./AboutCJ.module.css";
import PrimaryStationHeader from "@/reusable_sections/Header";
import FooterEcho from "@/reusable_sections/Footer";
import Aboutchloe from "./sections/Aboutchloe";
export default function AboutCJPage() {
  return <div>
      <PrimaryStationHeader />
      <Aboutchloe />
      <FooterEcho />
    </div>;
}